import { useEffect, useState } from "react";
import { Check, Crown } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card, Btn } from "@/components/portal/ui";
import { StatusMarker } from "@/components/portal/StatusMarker";

export function Packages() {
  const { t, L } = useI18n();
  const [pkgs, setPkgs] = useState([]);
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const [p, s] = await Promise.all([api.get("/packages"), api.get("/subscriptions/me")]);
    setPkgs(p.data);
    setSub(s.data);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);

  const subscribe = async (id) => {
    await api.post("/subscriptions", { package_id: id });
    toast.success(t("common.saved"));
    load();
  };

  if (loading) return <div className="text-sm py-10" style={{ color: "var(--text-muted)" }}>{t("common.loading")}</div>;

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <StatusMarker kind="gateway_not_connected" testid="packages-payment-marker" />
        <span className="text-xs" style={{ color: "var(--text-muted)" }}>{t("marker.payments.note")}</span>
      </div>
      <div className="grid md:grid-cols-3 gap-4" data-testid="packages-grid">
      {pkgs.map((p, i) => {
        const current = sub?.package_id === p.id;
        const pro = p.tier !== "basic";
        return (
          <Card
            key={p.id}
            data-testid={`package-${p.tier}`}
            className="p-6 flex flex-col kw-fade-up relative overflow-hidden"
            style={{ animationDelay: `${i * 70}ms`, borderColor: current ? "var(--accent)" : "var(--border)", borderWidth: current ? 2 : 1 }}
          >
            {p.tier === "premium" && <Crown className="absolute top-4 right-4 h-5 w-5" style={{ color: "var(--accent)" }} />}
            <div className="font-heading text-xl font-bold" style={{ color: "var(--text)" }}>{L(p.name)}</div>
            <div className="mt-2 flex items-baseline gap-1">
              <span className="text-4xl font-heading font-bold" style={{ color: "var(--text)" }}>
                {p.price === 0 ? t("pkg.free") : `${p.currency} ${p.price}`}
              </span>
              {p.price > 0 && <span className="text-sm" style={{ color: "var(--text-muted)" }}>/{t("pkg.month")}</span>}
            </div>
            <ul className="mt-4 space-y-2 flex-1">
              {L(p.features).map((f, k) => (
                <li key={k} className="flex items-start gap-2 text-sm" style={{ color: "var(--text-muted)" }}>
                  <Check className="h-4 w-4 mt-0.5 shrink-0" style={{ color: "var(--accent)" }} /> {f}
                </li>
              ))}
            </ul>
            <Btn
              variant={current ? "soft" : pro ? "primary" : "outline"}
              disabled={current}
              onClick={() => subscribe(p.id)}
              data-testid={`package-subscribe-${p.tier}`}
              className="mt-5 w-full"
            >
              {current ? `✓ ${t("pkg.active")}` : t("pkg.choose")}
            </Btn>
          </Card>
        );
      })}
      </div>
    </div>
  );
}
